@if (headerPosition === 'before') {
  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
}

  <div
    class="expansion-panel-content-wrap"
    [@nestedExpandCollapsePanel]="panelStatus() ? 'expanded' : 'hidden'"
    (@nestedExpandCollapsePanel.done)="animationFinished.emit()"
  >
    <ng-content></ng-content>
  </div>

@if (headerPosition === 'after') {
  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
}
